<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<!-- 添加汇报 -->
		<addHb :type="type" ref="addhb" @dataList="dataList"></addHb>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								style="margin-right: 10px;width: 200px;" 
								size="small"
								@input="getdata.page = 1;totalPage = 0;dataList();"
								v-model="getdata.u_name" placeholder="输入姓名查找"
								clearable>
							</el-input>
							<el-select
								size="small"
								style="margin-right: 10px;width: 100px !important;" 
								v-model="getdata.year" placeholder="选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
							<el-select
								size="small"
								style="width: 100px !important;" 
								v-model="getdata.month" placeholder="选择月份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $monthList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div id="">
							<el-button type="primary" size="small" v-if='$store.state.user.userinfo.flag == 1' @click="pubTixing">一键提醒</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							@selectEnable="selectEnable"
							:tableData="tableData"
							delkey="hyid"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="true"
							:selection="false">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import indexs from './mixins/index.js'
	export default{
		mixins: [indexs],
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
</style>

